<template>
  <Modal v-show="showModal">
    <FormCard
      :title="title"
      @accept="updateForecast"
      @cancel="cancelAction"
    >
      <ForecastFormContent
        @handleForecastData="setForecastData"
        @handleUpdatePhase="setPhaseColor"
        :forecastData="this.forecastData"
        :forecastDataValidation="this.forecastDataValidation"
      />
    </FormCard>
  </Modal>
</template>

<script>
import Modal from '@/components/atoms/Modals/Modal.vue';
import FormCard from '@/components/molecules/FormCard/FormCard.vue';
import ForecastFormContent from '@/components/molecules/Forecast/ForecastFormContent.vue';
import { hasData, getValidationState } from '@/helpers/ValidationHelper';
import { getPhaseColor } from '@/helpers/PhaseHelper';

export default {
  name: 'UpdateForecastForm',
  components: {
    Modal,
    FormCard,
    ForecastFormContent,
  },
  props: {
    showModal: Boolean,
    forecastData: {
      type: Object,
      default: () => {},
    },
    handleClose: {},
    handleUpdateForecasts: {},
  },
  data: () => ({
    title: 'Actualizar evento',
    forecastDataValidation: {
      startDate: null,
      endDate: null,
      phase: null,
      lot: null,
      color: null,
    },
  }),
  methods: {
    setForecastData(forecastData) {
      this.forecastData = forecastData;
    },
    updateForecast() {
      if (this.isValidData()) {
        this.blockScreen();

        const requestData = {
          project: this.$store.getters.getActiveProject,
          startDate: this.forecastData.startDate,
          endDate: this.forecastData.endDate,
          phase: this.forecastData.phase,
          lot: this.forecastData.lot,
          color: this.forecastData.color,
        };

        this.$store.dispatch('updateForecast', {
          uuid: this.forecastData.uuid,
          forecastData: requestData,
        })
          .then(() => {
            this.unBlockScreen();
            this.handleUpdateForecasts();
            this.closeForm();
          })
          .catch(() => {
            this.unBlockScreen();
            this.closeForm();
          });
      } else {
        this.forecastDataValidation = {
          startDate: getValidationState(this.forecastData?.startDate),
          endDate: getValidationState(this.forecastData?.endDate),
          phase: getValidationState(this.forecastData?.phase),
          lot: getValidationState(this.forecastData?.lot),
          color: getValidationState(this.forecastData?.color),
        };
      }
    },
    isValidData() {
      return hasData(this.forecastData?.startDate)
        && hasData(this.forecastData?.endDate)
        && hasData(this.forecastData?.phase)
        && hasData(this.forecastData?.lot)
        && hasData(this.forecastData?.color);
    },
    cancelAction() {
      this.$emit('cancel');
    },
    closeForm() {
      return this.handleClose();
    },
    setPhaseColor(phase) {
      this.forecastData.color = getPhaseColor(phase);
    },
  },
};
</script>
